import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Config from './base.config';
import protocol from '../protocol/fs.protocol';
import { EcoType } from '../const/enums';
/** 飞书使用APPLINK形式，任何场景下都支持 */

export var FsConfig = /*#__PURE__*/function (_Config) {
  _inheritsLoose(FsConfig, _Config);

  function FsConfig(options) {
    var _this;

    _this = _Config.call(this, options) || this;
    _this.protocol = protocol;
    _this.configType = EcoType.fs;
    _this.support = true;
    return _this;
  }
  /** 当前生态配套的统一协议入口 */


  var _proto = FsConfig.prototype;

  /** 与其他生态保持一致性，使用async */
  _proto.onReady =
  /*#__PURE__*/
  function () {
    var _onReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function onReady() {
      return _onReady.apply(this, arguments);
    }

    return onReady;
  }();

  return FsConfig;
}(Config);
/** DingTalkConfig 对象 单例模式 */

var configInstanse = null;
/**
 * 返回鉴权单例对象
 * @param options: Configure.Options 配置参数，只有在初次鉴权时才有效
 * @returns DingTalkConfig 配置对象
 */

var fs = function fs(options) {
  configInstanse = configInstanse || new FsConfig(options);
  return configInstanse;
};

export default fs;